import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ApiProvider } from '@restaurant/api-client';

import { App } from './App';
import { Shell } from './shell';

import { startErrorReporting } from '@restaurant/ui';
import '@restaurant/ui/tokens.css';

// The pass. Dark regardless of the operating system's preference: this screen
// hangs on a wall in a hot, bright kitchen and never follows anybody's desktop
// theme. Declaring the room also sets the type scale and hit targets for a
// screen read from two metres — see the note at the top of tokens.css.
document.documentElement.dataset.room = 'pass';

// First, so an error in the first render is reported too. A no-op unless this
// deployment has a DSN (packages/ui/src/error-reporting.ts).
startErrorReporting('kds');

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <ApiProvider baseUrl="" storageKey="restaurant.kds.token">
      <Shell appName="Kitchen Display" tagline="Sign in to open this station.">
        <App />
      </Shell>
    </ApiProvider>
  </StrictMode>,
);
